import _isNil from 'lodash/isNil';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Button from '@Components/Button/Button';
import TextInput from '@Components/DomElements/TextInput';
import LoadingButton from '@Components/LoadingButton/LoadingButton';
import Styles from '@Components/Settings/views/SettingsViews.scss';
import OrganizationsApi from '@Data/organizations/Api';
import { IUpdateOrganization } from '@Data/organizations/Interfaces';
import { selectedOrganizationState } from '@Data/organizations/Reducer';
import { ISettingsBaseComponentProps } from '../../Interfaces';

const emptyUpdateOrg: IUpdateOrganization = {
    organisation_id: '',
    organisation_name: '',
    owner_email: '',
};

const OrgInfoUpdateScreen = (props: ISettingsBaseComponentProps) => {
    const { title, setIsSubmitting, isSubmitting, id } = props;
    const selectedOrganization = useSelector(selectedOrganizationState);
    const [isEditing, setIsEditing] = useState<boolean>(false);
    const [updateOrgEntity, setUpdateOrgEntity] =
        useState<IUpdateOrganization>(emptyUpdateOrg);

    const handleCancelUpdateOrganization = () => {
        setIsEditing(false);
        if (!_isNil(selectedOrganization)) {
            setUpdateOrgEntity({
                ...(selectedOrganization as IUpdateOrganization),
            });
        }
    };

    const handleSetEditing = () => {
        setUpdateOrgEntity({
            ...(selectedOrganization as IUpdateOrganization),
        });
        setIsEditing(true);
    };

    const submitCleanup = async (orgId: string) => {
        await OrganizationsApi.getOrganizations(null, orgId);
        setIsSubmitting(false);
        setIsEditing(false);
        setUpdateOrgEntity(emptyUpdateOrg);
    };

    const handleSubmitUpdateOrganization = async () => {
        setIsSubmitting(true);
        await OrganizationsApi.updateOrganization(
            selectedOrganization.organisation_id,
            updateOrgEntity.organisation_name,
            selectedOrganization.owner_email,
            selectedOrganization.is_active
        );
        await submitCleanup(selectedOrganization.organisation_id);
    };

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setUpdateOrgEntity({
            ...updateOrgEntity,
            [e.target.name]: e.target.value,
        });
    };

    const inputValue = isEditing
        ? updateOrgEntity.organisation_name
        : selectedOrganization.organisation_name;

    return (
        <div className={Styles.settingsViewWrapper}>
            <div className={Styles.settingsViewHeader}>
                <span id={`${id}-title`}>{title}</span>

                <div>
                    {isEditing ? (
                        <React.Fragment>
                            <Button
                                id={`cancel-edit-${id}-btn`}
                                color={'black'}
                                onClick={handleCancelUpdateOrganization}
                            >
                                Cancel
                            </Button>
                            <LoadingButton
                                id={`submit-edit-${id}-btn`}
                                color={'success'}
                                loading={isSubmitting}
                                disabled={
                                    updateOrgEntity.organisation_name === '' ||
                                    updateOrgEntity.organisation_name ===
                                        selectedOrganization.organisation_name
                                }
                                onClick={handleSubmitUpdateOrganization}
                            >
                                Submit
                            </LoadingButton>
                        </React.Fragment>
                    ) : (
                        <Button
                            id={`edit-${id}-btn`}
                            color={'blue'}
                            onClick={handleSetEditing}
                        >
                            Edit
                        </Button>
                    )}
                </div>
            </div>
            <div className={Styles.settingsViewContent}>
                <TextInput
                    id={`edit-${id}-input`}
                    label={'Organization Name'}
                    name={'organisation_name'}
                    value={inputValue}
                    containerStyle={{ width: '100%' }}
                    onChange={onChange}
                    isEditing={isEditing}
                    disabled={isSubmitting}
                />
            </div>
        </div>
    );
};

export default OrgInfoUpdateScreen;
